<template>
  <!-- 承运商报价 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <span>{{customerName}}</span>
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="clickReturnList"
        >返回</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickAdd"
        >新建报价</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickDels"
        >批量删除</el-button>
        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="180px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click.stop="clickSettings(scope.row)"
              >设置</el-button>
              <el-button
                class="rbtns"
                @click.stop="clickAdd(scope.row)"
              >修改</el-button>
              <el-button
                class="rbtns"
                @click.stop="clickDels(scope.row)"
              >删除</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div
        class="formbox"
        v-if="isShowDialogDispatch"
      >
        <el-form
          class="glo_formBox"
          label-width="120px"
        >
          <div class="formBox_item">
            <el-form-item
              label="报价名称:"
              required
            >
              <el-input
                v-model="dialogFormDispatch.channelName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="计费方式:"
              required
            >
              <el-select
                v-model="dialogFormDispatch.formulaBillingWeightId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in out_going_billing_method_list"
                  :key="item.formulaBillingWeightId"
                  :label="item.formulaBillingWeightName"
                  :value="`${String(item.formulaBillingWeightId)}`"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="体积重量系数:"
              required
            >
              <el-input
                v-model="dialogFormDispatch.channelDivisor"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item">
            <el-form-item
              label="重量体积系数:"
              required
            >
              <el-input
                v-model="dialogFormDispatch.channelDivisorWeight"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="货物类型:"
              required
            >
              <el-select
                filterable
                clearable
                v-model="dialogFormDispatch.goodsTypeConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in waybillTypeList"
                  :key="index"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="运输方式:"
              required
            >
              <el-select
                filterable
                clearable
                v-model="dialogFormDispatch.transportMethodConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in transportModeList"
                  :key="index"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="llrrl">
            <aside class="ll">干线报价区间范围：</aside>
            <div class="rr">
              <div
                class="rritem"
                v-for="(item, index) in dialogFormDispatch.lineOfferWeights"
                :key="index"
              >
                <el-input
                  class="inputrr"
                  v-if="index==0"
                  v-model="item.startWeight"
                  placeholder="请输入"
                  disabled
                ></el-input>
                <el-input
                  class="inputrr"
                  v-else
                  v-model="dialogFormDispatch.lineOfferWeights[index - 1].endWeight"
                  placeholder="请输入"
                  disabled
                ></el-input>
                <span>至</span>
                <el-input
                  class="inputrr"
                  v-model="item.endWeight"
                  @input="onInput1(index)"
                  placeholder="请输入"
                ></el-input>
                <i
                  v-if="index>0"
                  class="el-icon-delete"
                  @click="clickDel(index)"
                ></i>
              </div>
              <el-button
                style="margin-top: 10px"
                size="small"
                class="glo_bgcMainColor"
                @click="addQujian"
              >添加区间</el-button>
            </div>
          </div>
          <div class="llrrl">
            <aside class="ll">送货费报价区间范围：</aside>
            <div class="rr">
              <div
                class="rritem"
                v-for="(item, index) in dialogFormDispatch.dispatchOfferWeights"
                :key="index"
              >
                <el-input
                  class="inputrr"
                  v-if="index==0"
                  v-model="item.startWeight"
                  placeholder="请输入"
                  disabled
                ></el-input>
                <el-input
                  class="inputrr"
                  v-else
                  v-model="dialogFormDispatch.dispatchOfferWeights[index - 1].endWeight"
                  placeholder="请输入"
                  disabled
                ></el-input>
                <span>至</span>
                <el-input
                  class="inputrr"
                  v-model="item.endWeight"
                  @input="onInput2(index)"
                  placeholder="请输入"
                ></el-input>
                <i
                  v-if="index>0"
                  class="el-icon-delete"
                  @click="clickDel1(index)"
                ></i>
              </div>
              <el-button
                style="margin-top: 10px"
                size="small"
                class="glo_bgcMainColor"
                @click="addQujian1"
              >添加区间</el-button>
            </div>
          </div>
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="备注:"
          >
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
  </div>
</template>
<script>
import _ from 'lodash'
import tableList from '@/pages/tableList.js'
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import queryBtns from '@/components/queryBtns.vue'
import queryCondition from '@/components/queryCondition.vue'
import myDialog from '@/components/Dialog.vue'
import exportjs from '@/assets/js/Mixins/exportDT.js' //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ['reload'],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '客户报价', //导出时默认文件名
        apiName: '/v1/common/query/runPageReport', //导出的数据列表接口名(动态列表都是这个)
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'POST', //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: 'Customers_CustomCarrierQuotation', //  页面标识
      reportFiledsNumber: 'admin_customer_channel_list', // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: '新增',
      diaWidthDispatch: '60%',
      dialogFormDispatch: {
        channelName: '',
        formulaBillingWeightId: '',
        channelDivisor: '',
        channelDivisorWeight: '',
        goodsTypeConfDictId: '',
        transportMethodConfDictId: '',
        comment: '',
        dispatchOfferWeights: [
          {
            operationType: 'ADD',
            startWeight: 0,
            endWeight: '',
          },
        ],
        lineOfferWeights: [
          {
            operationType: 'ADD',
            startWeight: 0,
            endWeight: '',
          },
        ],
      },
      customerNumber: '',
      customerId: '',
      customerName: '',
      out_going_billing_method_list: [],
      waybillTypeList: [],
      transportModeList: [], //运输方式
      old_dispatchOfferWeights: [],
      old_lineOfferWeights: [],
    }
  },
  mounted() {
    this.formula_billing_weight_down_list()
    this.getConfDictValDownList('waybill_type')
    this.getConfDictValDownList('transport_method')
  },
  activated() {
    const { customerId, customerNumber, customerName } = this.$route.query
    if (customerId) {
      this.customerNumber = customerNumber
      this.customerId = customerId
      this.customerName = customerName
      this.initTable()
    }
  },
  watch: {},
  methods: {
    onInput1(index) {
      let { weightSectionId } = this.dialogFormDispatch.lineOfferWeights[index]
      let result = this.old_lineOfferWeights.filter((item) => {
        return item.weightSectionId == weightSectionId
      })
      if (result.length) {
        this.dialogFormDispatch.lineOfferWeights[index].operationType = 'UPDATE'
      }
    },
    onInput2(index) {
      let { weightSectionId } =
        this.dialogFormDispatch.dispatchOfferWeights[index]
      let result = this.old_dispatchOfferWeights.filter((item) => {
        return item.weightSectionId == weightSectionId
      })
      if (result.length) {
        this.dialogFormDispatch.dispatchOfferWeights[index].operationType =
          'UPDATE'
      }
    },
    addQujian() {
      this.dialogFormDispatch.lineOfferWeights.push({
        operationType: 'ADD',
        startWeight: '',
        endWeight: '',
      })
    },
    clickDel(index) {
      this.dialogFormDispatch.lineOfferWeights.splice(index, 1)
    },
    addQujian1() {
      this.dialogFormDispatch.dispatchOfferWeights.push({
        operationType: 'ADD',
        startWeight: '',
        endWeight: '',
      })
    },
    clickDel1(index) {
      this.dialogFormDispatch.dispatchOfferWeights.splice(index, 1)
    },
    clickSettings({ channelId, channelName }) {
      this.$router.push({
        path: '/Customers/CustomLineQuotation',
        query: {
          channelId,
          channelName,
          customerId: this.customerId,
          customerName: this.customerName,
          customerNumber: this.customerNumber,
        },
      })
    },
    clickReturnList() {
      this.$router.push({
        path: '/Customers/Custom',
      })
    },
    getData() {
      let conditionReqs = []
      let F_config = this.$refs.queryForm.F_config
      F_config.forEach((element) => {
        let {
          textBoxType,
          conditonKey,
          dropdownSubmitField,
          conditonVal,
          timeType,
          timeChilds,
          startTime_a,
          endTime_a,
        } = element
        switch (textBoxType) {
          case 'input':
            if (conditonKey == 'customerId') {
              conditionReqs.push({
                conditonKey,
                conditonVal: this.customerId,
              })
            } else {
              conditionReqs.push({
                conditonKey,
                conditonVal,
              })
            }
            break
          case 'input_more':
            conditionReqs.push({
              conditonKey,
              conditonVal: (conditonVal && conditonVal.split("/")) || [],
            })
            break
          case 'select':
            conditionReqs.push({
              conditonKey: dropdownSubmitField || conditonKey,
              conditonVal,
            })
            break
          case 'datetime':
            let curs = timeChilds[timeType]
            curs &&
              curs.children.forEach((element, index) => {
                let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : ''
                let startTime_agg = startTime_a ? `${startTime_a} 00:00:00` : ''
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal: index == 1 ? endTime_agg : startTime_agg,
                })
              })
            break
          default:
            break
        }
      })
      let params = {
        conditionReqs,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        number: this.reportFiledsNumber,
      }
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === 'success') {
          let datas = res.data.result.datas || {}
          this.className = datas.className || ''
          this.tableData = datas.data || []
          this.pageCount = datas.pageCount || 0
          this.$nextTick(() => {
            this.fetTableHeight()
          })
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },
    async clickAdd(row) {
      if (row.channelId) {
        this.dialogTitleDispatch = '修改报价'
        await this.$API
          .offergetChannelDetail({
            channelId: row.channelId,
          })
          .then((res) => {
            if (res.data.status === 'success') {
              let datas = res.data.result || []
              if (datas.length) {
                let {
                  channelName,
                  formulaBillingWeightId,
                  channelDivisor,
                  channelDivisorWeight,
                  goodsTypeConfDictId,
                  transportMethodConfDictId,
                  comment,
                  dispatchOfferWeights,
                  lineOfferWeights,
                } = datas[0] || {}
                let arrs1 = []
                dispatchOfferWeights.forEach((element) => {
                  const {
                    operationType = 'UNCHANGED',
                    weightSectionId,
                    startWeight,
                    endWeight,
                    serialNumber,
                  } = element
                  arrs1.push({
                    operationType,
                    weightSectionId,
                    startWeight,
                    endWeight,
                    serialNumber,
                  })
                })
                let arrs2 = []
                lineOfferWeights.forEach((element) => {
                  const {
                    operationType = 'UNCHANGED',
                    weightSectionId,
                    startWeight,
                    endWeight,
                    serialNumber,
                  } = element
                  arrs2.push({
                    operationType,
                    weightSectionId,
                    startWeight,
                    endWeight,
                    serialNumber,
                  })
                })
                this.dialogFormDispatch = {
                  channelName,
                  formulaBillingWeightId: String(formulaBillingWeightId),
                  channelDivisor,
                  channelDivisorWeight,
                  goodsTypeConfDictId: String(goodsTypeConfDictId),
                  transportMethodConfDictId: String(transportMethodConfDictId),
                  comment,
                  dispatchOfferWeights: (arrs1.length && arrs1) || [
                    {
                      operationType: 'ADD',
                      startWeight: 0,
                      endWeight: '',
                    },
                  ],
                  lineOfferWeights: (arrs2.length && arrs2) || [
                    {
                      operationType: 'ADD',
                      startWeight: 0,
                      endWeight: '',
                    },
                  ],
                  channelId: row.channelId,
                }

                this.old_dispatchOfferWeights =
                  _.cloneDeep(dispatchOfferWeights)
                this.old_lineOfferWeights = _.cloneDeep(lineOfferWeights)
              }
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`)
            }
          })
      } else {
        this.dialogTitleDispatch = '新增报价'
      }
      this.isShowDialogDispatch = true
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false
      this.dialogFormDispatch = {
        channelName: '',
        formulaBillingWeightId: '',
        channelDivisor: '',
        channelDivisorWeight: '',
        goodsTypeConfDictId: '',
        transportMethodConfDictId: '',
        comment: '',
        dispatchOfferWeights: [
          {
            operationType: 'ADD',
            startWeight: 0,
            endWeight: '',
          },
        ],
        lineOfferWeights: [
          {
            operationType: 'ADD',
            startWeight: 0,
            endWeight: '',
          },
        ],
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      const {
        channelId,
        channelName,
        formulaBillingWeightId,
        channelDivisor,
        channelDivisorWeight,
        goodsTypeConfDictId,
        transportMethodConfDictId,
        comment,
        dispatchOfferWeights,
        lineOfferWeights,
      } = this.dialogFormDispatch
      if (!channelName) {
        this.$message.error('请输入报价名称')
        return false
      }
      if (!formulaBillingWeightId) {
        this.$message.error('请选择计费方式')
        return false
      }
      if (!channelDivisor) {
        this.$message.error('请输入体积重量系数')
        return false
      }
      if (!channelDivisorWeight) {
        this.$message.error('请输入重量体积系数')
        return false
      }
      if (!goodsTypeConfDictId) {
        this.$message.error('请选择货物类型')
        return false
      }
      if (!transportMethodConfDictId) {
        this.$message.error('请选择专车类型')
        return false
      }
      let arr1 = []
      dispatchOfferWeights.forEach((element, i) => {
        const {
          operationType,
          weightSectionId,
          startWeight,
          endWeight,
          serialNumber,
        } = element
        let n = {
          operationType,
          weightSectionId,
          startWeight,
          endWeight,
          serialNumber,
        }
        if (i > 0) {
          n.startWeight = dispatchOfferWeights[i - 1].endWeight
        }
        n.serialNumber = i + 1
        arr1.push(n)
      })
      if (channelId) {
        this.old_dispatchOfferWeights.forEach((m) => {
          if (
            !dispatchOfferWeights.filter((n) => {
              return m.weightSectionId == n.weightSectionId
            }).length
          ) {
            m.operationType = 'DEL'
            arr1.push(m)
          }
        })
      }

      let arr2 = []
      lineOfferWeights.forEach((element, i) => {
        const {
          operationType,
          weightSectionId,
          startWeight,
          endWeight,
          serialNumber,
        } = element
        let n = {
          operationType,
          weightSectionId,
          startWeight,
          endWeight,
          serialNumber,
        }
        if (i > 0) {
          n.startWeight = lineOfferWeights[i - 1].endWeight
        }
        n.serialNumber = i + 1
        arr2.push(n)
      })
      if (channelId) {
        this.old_lineOfferWeights.forEach((m) => {
          if (
            !lineOfferWeights.filter((n) => {
              return m.weightSectionId == n.weightSectionId
            }).length
          ) {
            m.operationType = 'DEL'
            arr2.push(m)
          }
        })
      }
      let params = {
        customerId: this.customerId,
        channelName,
        formulaBillingWeightId,
        channelDivisor,
        channelDivisorWeight,
        goodsTypeConfDictId,
        transportMethodConfDictId,
        comment,
        dispatchOfferWeights: arr1,
        lineOfferWeights: arr2,
      }
      if (channelId) {
        params.channelId = channelId
        this.$API.offerupdateCustomerOffer(params).then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.isShowDialogDispatch = false
          this.getData()
        })
      } else {
        this.$API.offeraddCustomerOffer(params).then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.isShowDialogDispatch = false
          this.getData()
        })
      }
    },
    clickDels(row) {
      if (row.channelId) {
        this.selectTableData = [row]
      }
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      let channelIds = []
      this.selectTableData.forEach((item) => {
        channelIds.push(item.channelId)
      })
      this.$confirm('确定要删除所选数据吗? 请谨慎操作', '提示:')
        .then((res) => {
          this.$API
            .offerdelChannel({ channelIds, customerId: this.customerId })
            .then((res) => {
              this.$message.success(res.data.message || '操作成功')
              this.getData()
            })
        })
        .catch((err) => {})
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        if (type == 'waybill_type') {
          // 货物类型
          this.waybillTypeList = res || []
        }
        if (type == 'transport_method') {
          // 获取运输方式列表
          this.transportModeList = res || []
        }
      }) //送货方式
    },
    formula_billing_weight_down_list() {
      this.$API
        .runPageReportDetails({
          number: 'formula_billing_weight_down_list',
        })
        .then((res) => {
          if (res.data.status === 'success') {
            let datas = res.data.result.datas || []
            this.out_going_billing_method_list = datas
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`)
          }
        })
    },
  },
}
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
.formBox_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: 32%;
  }
}
.llrrl {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  .ll {
    width: 150px;
  }
  .rr {
    .rritem {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .inputrr {
        width: 100px;
      }
      > span {
        padding: 0 10px;
      }
      .el-icon-delete {
        color: red;
        font-size: 20px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>